import { onReady } from "./utils/on-ready";
import { loopThroughElements } from "./utils/loop-through-elements";

export class Truncate {
    constructor() {
        onReady(this.applyTruncations);
    }

    applyTruncations = (): void => {
        const elements = document.querySelectorAll('[data-truncate]');
        loopThroughElements(elements, el => {
            const limit = parseInt(el.dataset.truncate);
            this.truncate(el, limit);
        });
    };

    truncate = (elem: HTMLElement, limit: number): void => {
        if (!elem || !limit)
            return;
        let text = elem.textContent.trim();
        const originalText = text;

        // Convert the content into an array of words
        // Remove any words above the limit
        const allWords = text.split(' ');
        if (allWords.length <= limit)
            return; // don't do anything if it's short enough
        const words = allWords.slice(0, limit);

        // Inject the content back into the DOM
        elem.textContent = words.join(' ');
        elem.appendChild(this.getTruncateExpandElement(elem, originalText));
    };

    getTruncateExpandElement = (element: HTMLElement, fullText: string) => {
        const expandEl = document.createElement('a');
        expandEl.text = 'READ MORE';
        expandEl.className = 'f-primary-btn';
        expandEl.onclick = (event: MouseEvent): void => {
            event.preventDefault();
            // clear out element
            while (element.firstChild) {
                element.removeChild(element.firstChild);
            }
            // set original text
            element.textContent = fullText;
        };

        // Two <br /> elements
        const lineBreak1 = document.createElement('br');
        const lineBreak2 = document.createElement('br');

        // Appending the <br /> elements before the anchor tag
        element.appendChild(lineBreak1);
        element.appendChild(lineBreak2);
        element.appendChild(expandEl);

        return expandEl;
    };
}
